import deleteReadings from './deleteReadings';

export default {
  deleteReadings,
};
